import { isNonRunner } from "../isNonRunner";
export const nonRunnerSelectionComparer = (s1, s2) => {
    return isNonRunner(s1) - isNonRunner(s2);
};
//# sourceMappingURL=nonRunnerSelectionComparer.js.map